@if(termsStatus){
    <div class="terms-bg" (click)="onClose()"></div>
}

<div [hidden]="!termsStatus" id="terms" class="terms" [@popup]="{value: termsStatus ? 'open' : 'closed'}" role="dialog" aria-label="terms and conditions popup">
  <div class="terms-container">
    <h2>
      <span [innerHtml]="'TERMS.HEAD' | translate"></span>
    </h2>

    @if(data.REG_DATE == undefined){
      <div id="terms-content" class="terms-content" tabindex="0">
        <p  [innerHtml]="'TERMS.DESC' | translate:data"></p>
      </div>
    }@else {
      <div id="terms-content" class="terms-content" tabindex="0">
        <p  [innerHtml]="'TERMS.DESC_CONFIRM' | translate:data"></p>
      </div>
    }
    <div tabindex="0" class="terms-close closeImg" (click)="onClose()" (keydown)="($event.key === 'Enter') && onClose()" aria-label="close terms and conditions popup" role="button"></div>
  </div>
</div>